import { HandlerFunc } from '../getRedirectPath';

const handleDoubleSlash: HandlerFunc = async ({ path }) => {
  return path.replace(/([^:]\/)\/+/g, '$1');
};

export default handleDoubleSlash;
